export const createContact = () => {
  return `mutation createContact (
    $firstName:String!,
    $lastName:String!,
    $email:String!,
    $phone:String,
    $content:String!
  ) {
      createContact(
          contact:{
            firstName: $firstName,
            lastName: $lastName,
            email: $email,
            phone: $phone,
            content: $content,
        }
    ){
        id
    }
  }`
}
